import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParametersService {

  private apiUrl: string;
  private apiEndpoint: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigService) {
    this.apiUrl = _appConfig.config.servicesBaseUrl;
    this.apiEndpoint = this.apiUrl + "/pmt";
  }

  getDeliveryAvailable(): Observable<any> {
    return this._http.get<any>(this.apiEndpoint + "/deliveryAvailable");
  }

}






